export default "__VITE_ASSET__D1J3t9vh__"